export default __webpack_public_path__ + "static/media/logo.08dedba6.png";